export const CHATS_PER_PAGE = 30;
